
export default {
  name: 'AnimationKeyframe',
  values: {
    width: undefined,
    height: undefined,
    transform: undefined,
    opacity: undefined,
    background: undefined,
    color: undefined,
  },
  meta: {
    extendable: false,
  },
}
